import ACSCallClient from 'SERVICES/callClient/ACSCallClient';

export default ACSCallClient;
